import styled from '@emotion/styled';

export const Container = styled.div`
	display: flex;
	flex-direction: column;
	gap: 2rem;
	max-width: 84.4rem;
	width: 100%;
	margin: 0 auto;
	padding: 8rem 0;
	@media screen and (max-width: 900px) {
		padding: 8rem 2rem;
	}
`;
export const Title = styled.h2`
	display: flex;
	justify-content: space-between;
	align-items: center;
	font-size: ${(props) => props.theme.fontSize.sizeXl};
	font-weight: ${(props) => props.theme.fontWeight.weightSemi};
	line-height: 130%;
	letter-spacing: -0.6px;
	@media (max-width: 900px) {
		flex-direction: column;
		align-items: unset;
		gap: 2rem;
	}
`;
export const PaymentButton = styled.button`
	background-color: #01337d;
	color: #fff;
	font-size: 1.6rem;
	font-weight: ${(props) => props.theme.fontWeight.weightRegular};
	line-height: 100%;
	letter-spacing: -0.6px;
	padding: 0rem 1.2rem;
	border: none;
	cursor: pointer;
	white-space: nowrap;
	height: 4.4rem;
	&:disabled {
		background-color: #e9ecef;
		color: #adb5bd;
		cursor: not-allowed;
	}
`;

export const SubTitle = styled.h3`
	font-size: ${(props) => props.theme.fontSize.sizeXl};
	font-weight: ${(props) => props.theme.fontWeight.weightSemi};
	line-height: 130%;
	letter-spacing: -0.6px;
`;
export const DescriptionBox = styled.div`
	display: flex;
	flex-direction: column;
	gap: 0.4rem;
`;
export const Description = styled.p`
	font-size: ${(props) => props.theme.fontSize.sizeLg};
	font-weight: ${(props) => props.theme.fontWeight.weightRegular};
	line-height: 140%;
	letter-spacing: -0.6px;
`;

export const Table = styled.table`
	width: 100%;
	border-collapse: collapse;
`;

export const TableHead = styled.thead``;

export const TableBody = styled.tbody``;

export const TableRow = styled.tr``;

export const TableHeadCell = styled.th`
	background-color: #f8f9fa;
	color: white;
	padding: 1rem 1.2rem;
	height: 5.2rem;
	text-align: left;
	border-right: 2px solid white;
	font-size: ${(props) => props.theme.fontSize.sizeMd};
	font-weight: ${(props) => props.theme.fontWeight.weightBold};
	color: #212529;
	text-align: center;
	vertical-align: middle;
`;

export const TableCellSuceess = styled.p`
	font-size: 1.6rem;
	font-weight: 400;
	line-height: 100%;
	letter-spacing: -0.6px;
	color: #16a34a;
`;
export const TableCellDanger = styled.p`
	font-size: 1.6rem;
	font-weight: 400;
	line-height: 100%;
	letter-spacing: -0.6px;
	color: #dc2626;
`;
export const TableCellPending = styled.p`
	font-size: 1.6rem;
	font-weight: 400;
	line-height: 100%;
	letter-spacing: -0.6px;
	color: #ca8a04;
`;
export const TableCell = styled.td`
	background-color: #fff;
	height: 5.2rem;
	padding: 10px 15px;
	border-right: 2px solid white;
	border-bottom: 2px solid white;
	font-size: ${(props) => props.theme.fontSize.sizeMd};
	font-weight: ${(props) => props.theme.fontWeight.weightRegular};
	line-height: 100%;
	letter-spacing: -0.6px;
	text-align: center;
	vertical-align: middle;
	border-bottom: 1px solid rgba(173, 181, 189, 0.4);
`;
export const PointCel = styled(TableCell)`
	color: ${(props) => props.theme.colors.primary400};
	font-weight: ${(props) => props.theme.fontWeight.weightBold};
`;
export const Button = styled.button`
	padding: 1.4rem 1.2rem;
	background-color: transparent;
	color: #01337d;
	border: 1px solid #01337d;
	font-size: ${(props) => props.theme.fontSize.sizeMd};
	font-weight: ${(props) => props.theme.fontWeight.weightRegular};
	line-height: 100%;
	letter-spacing: -0.6px;

	cursor: pointer;
`;
export const ButtonBox = styled.div`
	display: flex;
	flex-direction: column;
	gap: 1.2rem;
`;
export const CompleteStatus = styled(Button)`
	display: block;
`;
export const MobileCard = styled.div`
	display: flex;
	flex-direction: column;
	gap: 1.6rem;
	padding: 2rem;
	background-color: #f1f3f5;
`;
export const CardContentBox = styled.div`
	display: flex;
	flex-direction: column;
	gap: 1.2rem;
`;
export const MenuBox = styled.div`
	display: flex;
	gap: 1.6rem;
	font-size: 1.6rem;
	font-weight: 400;
	line-height: 100%;
	letter-spacing: -0.6px;
`;
export const CardMenu = styled.div`
	color: #495057;
	font-weight: 700;
	min-width: 6rem;
`;
export const PointMenu = styled(CardMenu)`
	color: ${(props) => props.theme.colors.primary400};
`;
